import React, {useEffect, useState} from "react";
import IndexPageSpecific from "./IndexPageSpecific";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import NoPageFound from "../NoPageFound/NoPageFound";
import AccessDenied from "../AccessDenied/AccessDenied";


function getIndexCompositeKey(url: string) {
    return url.substring(url.lastIndexOf('/') + 1, url.length);
};

interface IndexAccess {
    hasAccess: boolean,
    public: boolean
}

function IndexPageSpecificPrivateRedirection() {
    const indexCompositeKey = getIndexCompositeKey(window.location.href.toString());
    const [indexAccess, setIndexAccess] = useState<IndexAccess>();
    const [indexExists, setIndexExists] = useState(false);
    const [isLoadedP, setIsLoadedP] = useState(false);
    const [isLoadedE, setIsLoadedE] = useState(false);

    function redirectProtected() {
        window.location.href = '/dbiq-web/indices/protected/' + indexCompositeKey;
    }

    useEffect(() => {
        fetch('/dbiq-web/rest/webdata/' + indexCompositeKey + '/access')
            .then(res => res.json())
            .then(
                (result: IndexAccess) => {
                    setIndexAccess(result);
                    setIsLoadedP(true);
                },
                (error) => {
                    console.error(error);
                }
            )
    }, []);

    useEffect(() => {
        fetch('/dbiq-web/rest/webdata/' + indexCompositeKey + '/indexExists')
            .then(res => res.json())
            .then(
                (result) => {
                    setIndexExists(result);
                    setIsLoadedE(true);
                },
                (error) => {
                    console.error(error);
                }
            )
    }, []);


    function getViewBasedOnAccess() {
        if (!indexAccess) {
            return <NoPageFound/>;
        }

        if (indexAccess.public) {
            return <IndexPageSpecific/>;
        }

        if (indexAccess.hasAccess) {
            redirectProtected()
            return;
        }

        return <AccessDenied/>;
    }

    return ((isLoadedP && isLoadedE) ?
            (indexExists) ?
                getViewBasedOnAccess()
                :
                <NoPageFound/>
            :
            <Container fluid className="d-flex align-items-center justify-content-center"
                       style={{height: "250px"}}>
                <Spinner animation="border" role="status" variant="primary">
                </Spinner>
            </Container>
    )
}

export default IndexPageSpecificPrivateRedirection;
